import List from "@/components/list";
/*
 *  超级管理员可以修改readony=1的数据，其他角色不可以，有新增权限才可以操作
 */

let AccountTableConfig = []
const Table = args => {
  if (args.props.tabName == "视频") {
    AccountTableConfig = [
      {
        label: "学习内容",
        prop: "name",
        minWidth: "396",
      }, {
        label: "学习进度",
        prop: "progress",
        minWidth: "110",
      }, {
        label: "最后观看时间",
        prop: "lastTime",
        minWidth: "150",
      }, {
        label: "获得学时",
        prop: "credit",
        minWidth: "130",
      }
    ];
  } else if (args.props.tabName == "音频") {
    AccountTableConfig = [
      {
        label: "学习内容",
        prop: "name",
        minWidth: "396",
      }, {
        label: "学习进度",
        prop: "progress",
        minWidth: "110",
      }, {
        label: "最后听取时间",
        prop: "lastTime",
        minWidth: "150",
      }, {
        label: "获得学时",
        prop: "credit",
        minWidth: "130",
      }
    ];
  } else if (args.props.tabName == "考试") {
    AccountTableConfig = [
      {
        label: "考试名称",
        prop: "name",
        minWidth: "396",
      }, {
        label: "分数",
        prop: "examScore",
        minWidth: "110",
      }, {
        label: "交卷时间",
        prop: "lastTime",
        minWidth: "150",
      }, {
        label: "获得学时",
        prop: "credit",
        minWidth: "130",
      }
    ];
  } else if (args.props.tabName == "作业") {
    AccountTableConfig = [
      {
        label: "作业",
        prop: "name",
        minWidth: "396",
      }, {
        label: "提交时间",
        prop: "lastTime",
        minWidth: "150",
      }, {
        label: "获得学时",
        prop: "credit",
        minWidth: "130",
      }
    ];
  } else if (args.props.tabName == "奖惩") {
    AccountTableConfig = [
      {
        label: "奖惩内容",
        prop: "name",
        minWidth: "396",
      }, {
        label: "奖惩类型",
        prop: "punishmentName",
        minWidth: "110",
      }, {
        label: "奖惩时间",
        prop: "lastTime",
        minWidth: "150",
      }, {
        label: "获得学时",
        prop: "credit",
        minWidth: "130",
      }
    ];
  } else if (args.props.tabName == "中网院") {
    AccountTableConfig = [
      {
        label: "学习内容",
        prop: "name",
        minWidth: "396",
      }, 
      // {
      //   label: "学习进度",
      //   prop: "roleName",
      //   minWidth: "110",
      // }, 
      {
        label: "最后观看时间",
        prop: "lastTime",
        minWidth: "150",
      }, 
      {
        label: "获得学时",
        prop: "credit",
        minWidth: "130",
      }
    ];
  } else if (args.props.tabName == "直播课") {
    AccountTableConfig = [
      {
        label: "学习内容",
        prop: "name",
        minWidth: "396",
      }, {
        label: "学习时长",
        prop: "learnTime",
        minWidth: "110",
      }, {
        label: "最后观看时间",
        prop: "lastTime",
        minWidth: "150",
      }, {
        label: "获得学时",
        prop: "credit",
        minWidth: "130",
      }
    ];
  } else {
    AccountTableConfig = [
      {
        label: "内容",
        prop: "name",
        minWidth: "396",
      }, {
        label: "最后观看时间",
        prop: "lastTime",
        minWidth: "150",
      }, {
        label: "获得学时",
        prop: "credit",
        minWidth: "130",
      }
    ];
  }

  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
